import { render, staticRenderFns } from "./ConfirmCandidate.vue?vue&type=template&id=61bc5aa1&"
import script from "./ConfirmCandidate.vue?vue&type=script&lang=js&"
export * from "./ConfirmCandidate.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmCandidate.vue?vue&type=style&index=0&id=61bc5aa1&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports